import ApiClient from '@/services/apiClient';
import i18n from '@/i18n';

// Key of a license, as scanned or typed in the app: 5 groups of 5 characters
export const LICENSE_KEY_REGEX = /^[0-9A-Z]{5}(?:-[0-9A-Z]{5}){4}$/;

export default class License {
  id;
  name;
  maximum;
  start_date;
  duration;     // days
  unique_id;    // license key

  static constructFromObject(data, obj) {
    obj = obj || new License();
    if (data) {
        obj.id = ApiClient.convertToType(data['id'], 'Integer');
        obj.name = ApiClient.convertToType(data['name'], 'String');
        obj.maximum = ApiClient.convertToType(data['maximum'], 'Integer');
        obj.start_date = ApiClient.convertToType(data['start_date'], 'Date');
        obj.duration = ApiClient.convertToType(data['duration'], 'Integer');
        obj.unique_id = ApiClient.convertToType(data['unique_id'], 'String');
    }
    return obj;
  }

  toJSON() {
    const json = {
        id: this.id,
        name: this.name,
        maximum: this.maximum,
    }

    if(this.start_date) {
        json.start_date = this.start_date;
    }

    return json;
  }

  // Name with its maximum when limited, as in the app
  get type() {
    return this.name + (this.maximum > 0 ? ` (${this.maximum})` : '');
  }

  // Start date plus the duration, shown like the app (day, short month, year of the UTC date)
  get expirationDate() {
    if(!this.start_date || this.duration == null || isNaN(this.start_date)) return '';
    const date = new Date(this.start_date.getTime() + this.duration * 24 * 3600 * 1000);
    const locale = i18n.global.locale.value === 'co' ? 'fr' : i18n.global.locale.value;
    return new Intl.DateTimeFormat(locale, { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(date);
  }
}
